<template>
    <div class="empty-layout">
        <Header />
        <main id="content">
            <div class="container">
                <router-view></router-view>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
    import Header from "@/components/Header"
    import Footer from "@/components/Footer"

    export default {
        name: "empty-layout",
        components: {
            Header,
            Footer
        },
    }

</script>